import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { appLocales } from 'app/lang/messages';
import { selectLanguage } from './langActions';
import { Select } from 'sa-ui';

import './LanguageSelect.scss';

class LanguageSelect extends PureComponent {
  handleChange = e => {
    this.props.selectLanguage(e.target.value);
  };
  render() {
    const { locale } = this.props;
    const options = this.props.countries.map(c => ({ value: c.language, label: c.name }));
    if (options.length <= 1) return null;
    return (
      <Select
        value={locale}
        onChange={this.handleChange}
        className="language-select"
        options={options}
      />
    );
  }
}

LanguageSelect.propTypes = {
  selectLanguage: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  countries: PropTypes.array.isRequired,
};

const mapStateToProps = ({ login, lang }) => ({ locale: lang.locale, countries: login.countries });

export default connect(
  mapStateToProps,
  { selectLanguage },
)(LanguageSelect);
